/* tslint:disable */
/* eslint-disable */
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Pagination } from './Pagination';
import {
    PaginationFromJSON,
    PaginationFromJSONTyped,
    PaginationToJSON,
    PaginationToJSONTyped,
} from './Pagination';
import type { ReportBradfordFactor } from './ReportBradfordFactor';
import {
    ReportBradfordFactorFromJSON,
    ReportBradfordFactorFromJSONTyped,
    ReportBradfordFactorToJSON,
    ReportBradfordFactorToJSONTyped,
} from './ReportBradfordFactor';

/**
 * 
 * @export
 * @interface ListBradfordFactorReportResponse
 */
export interface ListBradfordFactorReportResponse {
    /**
     * 
     * @type {Array<ReportBradfordFactor>}
     * @memberof ListBradfordFactorReportResponse
     */
    data: Array<ReportBradfordFactor>;
    /**
     * 
     * @type {Pagination}
     * @memberof ListBradfordFactorReportResponse
     */
    pagination: Pagination;
}

/**
 * Check if a given object implements the ListBradfordFactorReportResponse interface.
 */
export function instanceOfListBradfordFactorReportResponse(value: object): value is ListBradfordFactorReportResponse {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('pagination' in value) || value['pagination'] === undefined) return false;
    return true;
}

export function ListBradfordFactorReportResponseFromJSON(json: any): ListBradfordFactorReportResponse {
    return ListBradfordFactorReportResponseFromJSONTyped(json, false);
}

export function ListBradfordFactorReportResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ListBradfordFactorReportResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(ReportBradfordFactorFromJSON)),
        'pagination': PaginationFromJSON(json['pagination']),
    };
}

  export function ListBradfordFactorReportResponseToJSON(json: any): ListBradfordFactorReportResponse {
      return ListBradfordFactorReportResponseToJSONTyped(json, false);
  }

  export function ListBradfordFactorReportResponseToJSONTyped(value?: ListBradfordFactorReportResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': ((value['data'] as Array<any>).map(ReportBradfordFactorToJSON)),
        'pagination': PaginationToJSON(value['pagination']),
    };
}

